import { BaseAPI } from '../manager/base';
import type { OrderOperationLog } from '../../types/process/operation-log';

export class OperationLogAPI extends BaseAPI<OrderOperationLog> {
  constructor() {
    super('/operation-logs');
  }
}

export const operationLogApi = new OperationLogAPI();


